
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkCalculationTemplateItemSortOrderEntryDto } from '../models/work-calculation-template-item-sort-order-entry-dto';

export function getUpdateCalculationTemplateItemSortOrderDtoFormGroup() {
return new FormGroup({
    calculationTemplateId: new FormControl<number | undefined>(undefined, [Validators.required]),
    updates: new FormControl<WorkCalculationTemplateItemSortOrderEntryDto[]>([]),
})
;
}
      